import type { FC } from "react"
import React from "react"
import { useFormContext } from "react-hook-form"

import FileArea from "@/components/upload/components/FileArea"
import { ALLOWED_TYPE_LABEL_IMAGES_WITH_PDF_AND_DOC } from "@/components/upload/constants"
import { ReferenceTableName } from "@/graphql/codegen/graphql"
import FileTypeSelect from "@/screens/Companies/edit/components/info/components/form/FileTypeSelect"
import { ALLOWED_FILE_FORMATS } from "@/screens/Companies/edit/components/info/constants"
import type { CompanyFileFormValues } from "@/screens/Companies/edit/components/info/schema/CompanyFileSchema"

const CompanyFileForm: FC<{
  onSubmit: () => void
}> = ({ onSubmit }) => {
  const methods = useFormContext<CompanyFileFormValues>()
  const fileType = methods.watch("fileType")

  return (
    <form onSubmit={onSubmit}>
      <FileTypeSelect name='fileType' />
      <FileArea<CompanyFileFormValues>
        name='file'
        fieldGroups={fileType ? [fileType] : undefined}
        referenceTableName={ReferenceTableName.Company}
        allowedMimeTypes={ALLOWED_FILE_FORMATS}
        allowedTypesLabel={ALLOWED_TYPE_LABEL_IMAGES_WITH_PDF_AND_DOC}
      />
    </form>
  )
}

export default CompanyFileForm
